module.exports = __webpack_public_path__ + "static/media/Anime-Pocket-01.17417da6.jpg";